import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import axios from "axios";
import { BASE_API_URL } from "../const";

const Register = ({ onClose, onRegisterSuccess }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const handleRegister = async () => {
    try {
      const response = await axios.post(`${BASE_API_URL}/api/user/register`, {
        login: login,
        email: email,
        password: password,
      });
      const { success, token } = response.data;

      if (success) localStorage.setItem("lionsarena.Login", login);

      if (success && token) {
        // localStorage.setItem("lionsarena.Login", login);
        localStorage.setItem("lionsarena.Token", token);
        onRegisterSuccess();
        onClose();
      } else {
        alert(
          "Регистрация прошла, но токен не получен. Ожидайте подтверждения."
        );
        onClose();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data.error.message ||
        "Произошла ошибка при регистрации";
      alert(`Ошибка регистрации: ${errorMessage}`);
      setLogin("");
      setPassword("");
      setEmail("");
    }
  };

  return (
    <Box p={2} display="flex" flexDirection="column" gap={2}>
      <TextField
        label="Login"
        value={login}
        onChange={(e) => setLogin(e.target.value)}
      />
      <TextField
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <TextField
        label="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button variant="contained" onClick={handleRegister}>
        Зарегистрироваться
      </Button>
    </Box>
  );
};

export default Register;
